import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@onefootprint/ui';
import type React from 'react';
import { useTranslation } from 'react-i18next';
export type ConfirmationDialogProps = {
  children: React.ReactNode;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  title: string;
};
const ConfirmationDialog = t0 => {
  const $ = _c(21);
  const {
    children,
    isPending,
    onClose,
    onConfirm,
    open,
    title
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isPending || $[3] !== onConfirm || $[4] !== t1) {
    t2 = {
      label: t1,
      loading: isPending,
      onClick: onConfirm
    };
    $[2] = isPending;
    $[3] = onConfirm;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp2);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isPending || $[9] !== onClose || $[10] !== t3) {
    t4 = {
      disabled: isPending,
      label: t3,
      onClick: onClose
    };
    $[8] = isPending;
    $[9] = onClose;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== children) {
    t5 = <p className="text-body-2 text-secondary text-center fp-text max-md:break-words">{children}</p>;
    $[12] = children;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== onClose || $[15] !== open || $[16] !== t2 || $[17] !== t4 || $[18] !== t5 || $[19] !== title) {
    t6 = <Dialog size="compact" open={open} onClose={onClose} title={title} primaryButton={t2} secondaryButton={t4}>{t5}</Dialog>;
    $[14] = onClose;
    $[15] = open;
    $[16] = t2;
    $[17] = t4;
    $[18] = t5;
    $[19] = title;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default ConfirmationDialog;
function _temp($) {
  return $.confirm.cta;
}
function _temp2($_0) {
  return $_0.confirm.cancel;
}